import { z } from "zod";
import { DISTRIBUTION_LEVEL, GL_MASTER_ID, MONTH_RANGE } from "./consts";

export const schema = z.object({
  [MONTH_RANGE]: z.object({
    from: z.date({
      required_error: "This field is required",
    }),
    to: z.date({
      required_error: "This field is required",
    })
  }),
  [GL_MASTER_ID]: z.array(z.string()).min(1, "This field is required"),
  [DISTRIBUTION_LEVEL]: z.string().min(1, "This field is required")
});

export type formValues = z.infer<typeof schema>;